/**
 * handleItemDragOver
 * Callback function get additional classes when item is dragged over.
 */
export const getClassForDragOver = (props, isDraggingOver, draggingOverWith) => {
  const { canItemDragOver, draggingOverClass, draggingOverErrorClass } = props;
  if (isDraggingOver) {
    return canItemDragOver(draggingOverWith) ? draggingOverClass : draggingOverErrorClass;
  }
  return '';
};
